import { Stack, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ArmScaleIcon } from '@shared/custom-icons';

interface Props {
  basePriceUnit: string;
  unit: string;
  gtin: string;
}

export function PackageInfo({ basePriceUnit, unit, gtin }: Props) {
  const t = useMyAssortmentTFunction();
  return (
    <Stack gap={3} px={2} direction="row" alignItems="center">
      <Stack direction="row" gap={1} justifyContent="center">
        <Typography variant="body2">{t('myAssortment.productCard.priceUnit')}:</Typography>
        <Typography variant="subtitle2">{basePriceUnit ?? '-'}</Typography>
      </Stack>

      <Stack direction="row" gap={1} justifyContent="center" alignItems="center">
        <Typography variant="body2">{t('myAssortment.packages.unit')}:</Typography>
        {unit}
        {!gtin && <ArmScaleIcon fontSize="small" />}
      </Stack>

      {gtin && (
        <Stack direction="row" gap={1} justifyContent="center">
          <Typography variant="body2">{t('myAssortment.packages.gtin')}:</Typography>
          <Typography variant="subtitle2">{gtin}</Typography>
        </Stack>
      )}
    </Stack>
  );
}
